import { VideoPlayerProps } from 'typings';
import { safeParse } from './utils/safe-parse';

export const config: VideoPlayerProps = {
  videoGUID: process.env.VIDEO_GUID ?? 'MBF0003',
  language: process.env.LANGUAGE ?? 'en_US',
  autoplay: process.env.AUTOPLAY === 'true',
  extraHeartbeatParams: safeParse(process.env.EXTRA_HEARTBEAT_PARAMS) ?? { activitySync: true },
  config: {
    cocoaApiUrl: process.env.COCOA_API_URL ?? 'https://cocoa-echo.qa.cd.beachbodyondemand.com/v1.0',
    cocoaApiKey: process.env.COCOA_API_KEY ?? 'RVDpxtITDvaljcNbsv01e16X6Liv2W3T9KSkwjcf',
    videoApiRetryAttempts: Number(process.env.VIDEO_API_RETRY_ATTEMPTS ?? 2),
    vhsApiUrl: process.env.VHS_API_URL ?? 'https://api-echo.qa.cd.beachbodyondemand.com/vhs/v3/heartbeats',
    vhsApiKey: process.env.VHS_API_KEY ?? 'RVDpxtITDvaljcNbsv01e16X6Liv2W3T9KSkwjcf',
    muxEnvKey: process.env.MUX_ENV_KEY ?? 'kjdpesl7bh8mc50o960qntkkq',
    muxPlayerName: process.env.MUX_PLAYER_NAME ?? 'bodi-web',
    muxDisableCookies: process.env.MUX_DISABLE_COOKIES === 'true',
    muxRespectDoNotTrack: process.env.MUX_RESPECT_DO_NOT_TRACK === 'true',
    muxIsEnabled: process.env.MUX_IS_ENABLED === 'true',
    tracksIsEnabled: process.env.TRACKS_IS_ENABLED === 'true',
    chromecastAppId: process.env.CHROMECAST_APP_ID ?? '056D7D4B',
    playbackControlsEnabled: process.env.PLAYBACK_CONTROLS_ENABLED === 'true',
    maxBitrateForEdge: Number(process.env.MAX_BITRATE_FOR_EDGE ?? 5000000),
    skipResume: process.env.SKIP_RESUME === 'true',
    debug: process.env.DEBUG === 'true',
    logging: process.env.LOGGING === 'true',
    useBodwebHeader: process.env.USE_BODWEB_HEADER === 'true',
    simulateVideoApiAuthorizer: process.env.SIMULATE_VIDEO_API_AUTHORIZER === 'true',
  },
};
